<nav
  class="ap-navigation-wrapper"
  [class.collapse-nav]="collapsedValue()"
  [class.solid-nav]="solid()">
  <div class="ap-navigation-content ap-navigation-content-simple">
    @for (item of navList(); track $index) {
      @if ($index !== 0) {
        <div class="ap-navigation-divider"></div>
      }
      <gstar-navigation-item
        [disabled]="isItemDisabled(item)"
        [selected]="
          isSelected($index, selectedIndexValue()) && !hasChildren(item)
        "
        [active]="item.active"
        [collapsed]="collapsedValue()"
        [content]="item.name"
        [item]="item"
        (clickTrigger)="onClickParentItem(item)"
        (keyupTrigger)="onClickParentItem(item)" />
      @if (item.children && item.children.length > 0) {
        @if (item.hasFilter) {
          <div
            class="nav-item-child"
            [class.open]="item.open"
            [class.hidden]="!item.open">
            <ng-content></ng-content>
          </div>
        }
        <div
          class="nav-item-child"
          [class.open]="item.open"
          [class.hidden]="!item.open">
          @for (
            subItem of item.children;
            track subItem.name;
            let indexChild = $index
          ) {
            <div class="nav-item">
              <gstar-navigation-item
                [disabled]="isItemDisabled(subItem)"
                [selected]="
                  isSelected(indexChild, selectedSubIndexValue()) &&
                  !hasChildren(subItem)
                "
                [active]="subItem.active"
                [collapsed]="collapsedValue()"
                [content]="subItem.name"
                [item]="subItem"
                (clickTrigger)="onClickSubItem(subItem)"
                (keyupTrigger)="onClickSubItem(subItem)" />
              @if (subItem.children && subItem.children.length > 0) {
                <div
                  class="nav-item-child last-child"
                  [class.open]="subItem.open"
                  [class.hidden]="!subItem.open">
                  @for (
                    lastItem of subItem.children;
                    track lastItem.name;
                    let lastIndex = $index
                  ) {
                    <div class="nav-item">
                      <gstar-navigation-item
                        [disabled]="isItemDisabled(lastItem)"
                        [selected]="
                          isSelected(lastIndex, selectedNestedIndexValue()) &&
                          !hasChildren(lastItem)
                        "
                        [active]="lastItem.active"
                        [collapsed]="collapsedValue()"
                        [content]="lastItem.name"
                        [item]="lastItem"
                        (clickTrigger)="onClickNestedItem(lastItem)"
                        (keyupTrigger)="onClickNestedItem(lastItem)" />
                    </div>
                  }
                </div>
              }
            </div>
          }
        </div>
      }
    }
  </div>
  <div class="ap-navigation-footer">
    @if (hasFooter()) {
      <div
        class="ap-navigation-item collapsed-item"
        [attr.aria-expanded]="collapsedValue()"
        (click)="onCollapsed($event)"
        (keyup.enter)="onCollapsed($event)"
        role="none">
        <div class="prefix-content">
          @if (collapsedValue()) {
            <span
              class="prefixIcon appkit-icon Appkit4-icon icon-enter-right-outline"></span>
          } @else {
            <span
              class="prefixIcon appkit-icon Appkit4-icon icon-enter-left-outline"></span>
          }
        </div>
        <span class="item-content">Collapse</span>
      </div>
    }
  </div>
</nav>
